import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import merge from "lodash/merge";
import omitBy from "lodash/omitBy";
import set from "lodash/set";
import values from "lodash/values";
import { isValueEmpty } from "PFCore/helpers/filters";
import { Filters, Value } from "PFTypes";
import { FiltersMetaV2, FiltersV2, FilterV2WithValueOnly } from "PFTypes/filters_v2";

export const formatFilterV2ToApiFormat = (filters: FiltersV2<FilterV2WithValueOnly>): Filters<Value> => {
  const legacyFilters: Filters<Value> = {};

  values(filters)
    .filter(({ value }) => !isValueEmpty(value))
    .forEach(({ originalPath, value }) => set(legacyFilters, originalPath, value));

  return legacyFilters;
};

export const formatFiltersV2MetaToApiFormat = ({
  mainFilters,
  childrenFilters
}: Partial<FiltersMetaV2<FilterV2WithValueOnly>>): Filters<Value> | undefined => {
  const formattedFilters = omitBy(
    merge(
      {},
      formatFilterV2ToApiFormat(mainFilters || {}),
      childrenFilters ? { children: formatFilterV2ToApiFormat(childrenFilters) } : {}
    ),
    (filters) => isNil(filters) || isEmpty(filters)
  );

  return isEmpty(formattedFilters) ? undefined : formattedFilters;
};
